<template>
    <div>
        <el-button circle
                   size="small"
                   type="primary"
                   icon="el-icon-setting"
                   @click="onOpenSetting"></el-button>
        <popup-field-setting :cache-key="cacheKey"
                             ref="popup-field-setting"
                             @save="onSaveSetting"></popup-field-setting>
    </div>
</template>
<script>
import PopupFieldSetting from '@/components/PopupFieldSetting.vue'
export default {
    components: { PopupFieldSetting },
    props: {
        cacheKey: String,
        tableColumns: Array,
        selectedColumns: Array
    },
    data () {
        return {}
    },
    methods: {
        onOpenSetting () {
            this.$refs['popup-field-setting'].show(this.tableColumns, this.selectedColumns)
        },
        onSaveSetting (selected_columns) {
            this.$emit('save', selected_columns)
        }
    }
}
</script>
